export const validateEmailAddress = emailAddress => {
  return /\S+@\S+\.\S+/.test(emailAddress)
}
